import React from 'react'
import { Form, Row, Col, Label } from 'reactstrap'
import { Select } from 'components/select'
import {  ValidationResultButton } from 'components/buttons'
import { Validator } from 'components/validation'
import { DialogBase, dialogSizes } from 'dialogs/dialogBase'
import { localized } from 'decorators'

export class AddFilterDialog extends DialogBase {
  constructor (props, context) {
    super(props, context)

    this.state = {
      column: null
    }
  }
  save = () => {
    this.props.context.onSave(this.state)
    this.close()
  }
  modalButtons () { return <ValidationResultButton buttonTitle='common.ok' onClick={this.save} /> }
  modalSize () { return dialogSizes.MD }
  modalTitle () { return this.props.localize('addFilterDialog.title') }
  modalBody () {
    const { localize, context } = this.props
    const data = [...context.availableColumns]
    return (
      <Form>
        <Row>
          <Col sm='12'>
            <Label>{localize('addFilterDialog.select')}</Label>
            <Validator name='name' value={this.state.column} required>
              <Select
                data={data}
                value={this.state.column}
                getLabel={item => localize(`filters.column_${item.id}`)}
                onChange={column => this.setState({ column })}
              />
            </Validator>
          </Col>
        </Row>
      </Form>
    )
  }
}

export default localized(AddFilterDialog)
